<template>
  <swiper class="ads" :options="swiperOptions">
    <swiper-slide class="swiper-slide" v-for="item in adsList" :key="item.id">
      <img class="cover-img" :src="item.cover.url" @click.stop="onPageOpen(item)" />
    </swiper-slide>
  </swiper>
</template>

<script>
import 'swiper/dist/css/swiper.min.css';

export default {
  name: 'Ads',

  props: {
    adsList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      swiperOptions: {
        autoplay: 3000,
      },
    };
  },

  methods: {
    onPageOpen(item) {
      // 更新广告点击次数
      this.$http.post({
        name: 'ad.update',
        params: {
          id: item.id,
        }
      })
      window.location.href = item.url;
    },
  },
};
</script>

<style scoped>
.cover-img {
  width: 100vw;
  height: 540px;
}
</style>
